import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectAiSkillsState = createSelector(getSystem, ({ aiSkills }) => aiSkills);

export const selectAiSkills = createSelector(selectAiSkillsState, ({ skills }) => skills);

export const selectAiSkillTemplates = createSelector(
  selectAiSkillsState,
  ({ templates }) => templates,
);

export const selectAiSkillsWithEnabledTemplates = createSelector(
  [selectAiSkills, selectAiSkillTemplates],
  (skills, templates) => [
    ...skills.map(skill => ({ ...skill, isTemplate: false, isEnabled: true })),
    ...templates
      .filter(template => template.isEnabled)
      .map(template => ({ ...template, isTemplate: true })),
  ],
);

export const selectAiSkillById = id =>
  createSelector(selectAiSkillsWithEnabledTemplates, items => items.find(s => s.id === id));

export const selectAiSkillsOptions = createSelector(selectAiSkills, skills =>
  skills.map(({ id, displayName }) => ({ name: displayName, value: id })),
);
